import React from 'react'

import { Image } from 'react-bootstrap';
import { Row, Col } from 'react-bootstrap';
import FigmaProjects from "./figma"
import WordpressProjects from "./wordpress"
import LINE from "../images/line.webp";
import Project2 from "../images/02.webp";
import Project3 from "../images/03.webp";

function Projects() {
    return (
        <Col id="work" className="min-vh-100 justify-content-center mb-20">
            <h3 className="uppercase text-title text-white px-4">
                <span className="text-main">03. </span>What I've Worked On
            </h3>

            {/* Row for columns */}
            <Row className="grid grid-cols-1 lg:grid-cols-2 gap-5 w-full mb-10">
                {/* Left Column */}
                <Col className="relative flex-1 m-auto flex-col w-full sm:w-48 font-mono text-sm" xxl={4} xl={4} lg={4} md={11} sm={11} xs={11}>
                    <Image
                        src={LINE}
                        alt="Line Image"
                        width={300} // Adjust width as needed
                        height={'100%'} // Adjust height as needed
                        className="object-contain hover-soak text-center"
                    />
                </Col>

                {/* Right Column */}
                <Col className="relative m-auto flex-2 flex-col w-full sm:w-48 font-mono text-white py-3 px-5 custom-rounded flex justify-center box-hover">
                    <h3 className='text-xl font-bold mb-3'><span className='text-main'>Daily Sales Notification</span></h3>
                    <p className="font-mono text-jobs mt-1 mb-3">Developed and implemented an automated notification system to monitor and track daily sales performance for sales teams. This system is designed to efficiently deliver daily sales reports through a designated platform, ensuring timely and accurate insights for decision-making.</p>
                    <div className="text-main">Tools and frameworks I actively use.</div>
                    <Col className="mt-4 space-y-3 mb-5">
                        <p className="text-sm text-slate-400 mt-1"> ▹ app script</p>
                        <p className="text-sm text-slate-400 mt-1"> ▹ Figma</p>
                        <p className="text-sm text-slate-400 mt-1"> ▹ Messaging API</p>
                        <p className="text-sm text-slate-400 mt-1"> ▹ Flex message</p>
                    </Col>

                    <a href="/salenotify"
                        target="_blank"
                        rel="noopener noreferrer"
                        className=" px-5 py-3 border text-main custom-rounded text-center w-max" >
                        View Project
                    </a>

                </Col>
            </Row>


            <Row className="mb-10">
                {/* Left Column */}
                <Col className="text-white py-3 px-5 custom-rounded  \justify-center order-2 order-lg-1 box-hover" xxl={7} xl={7} lg={7} md={11} sm={11} xs={11}>
                    <h3 className='text-xl font-bold mb-3'>
                        <span className='text-main'>Aquaverse Online Ticket</span>
                    </h3>

                    <div className="font-mono text-jobs mt-1 mb-3">An online ticket booking system for Aquaverse Water Park, developed using React and supporting multiple languages with i18next. This project transforms the client’s UX/UI design into a fully functional website, integrating API connections for real-time ticket booking and data processing.</div>

                    <Row>
                        <Col>
                            <div className="text-main mb-2">Key Features</div>
                            <Col className="mt-2 space-y-3 mb-5 py-2">
                                <p className="text-sm text-slate-400 mt-1"> ▹ Multi-language support (Thai/English) with i18next</p>
                                <p className="text-sm text-slate-400 mt-1"> ▹ UI designed based on client-provided designs and implemented using React</p>
                                <p className="text-sm text-slate-400 mt-1"> ▹ API integration for real-time ticket booking and data retrieval</p>
                                <p className="text-sm text-slate-400 mt-1"> ▹ Responsive design for seamless use on all devices</p>
                                <p className="text-sm text-slate-400 mt-1"> ▹ High performance with optimized state management and data fetching</p>
                            </Col>
                        </Col>
                        <Col>
                            <div className="text-main mb-2">Tools and frameworks I actively use.</div>
                            <Col className="mt-2 space-y-3 mb-5 py-2">
                                <p className="text-sm text-slate-400 mt-1"> ▹ React</p>
                                <p className="text-sm text-slate-400 mt-1"> ▹ Bootstrap</p>
                                <p className="text-sm text-slate-400 mt-1"> ▹ CSS</p>
                                <p className="text-sm text-slate-400 mt-1"> ▹ REST API</p>
                            </Col>
                        </Col>
                    </Row>
                    <a href="https://buynow.columbiapicturesaquaverse.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className=" px-5 py-3 border text-main custom-rounded text-center w-max" >
                        View Project
                    </a>
                </Col>

                {/* Right Column */}
                <Col className="relative font-mono text-sm py-3 order-1 order-lg-2" xxl={5} xl={5} lg={5} md={12} sm={12} xs={12}>
                    <a href="https://buynow.columbiapicturesaquaverse.com/" target="_blank" rel="noopener noreferrer">
                        <Image
                            src={Project2}
                            alt="Aquaverse Ticket Image"
                            className="object-contain custom-rounded hover-soak px-2" width={'100%'}
                        />
                    </a>
                </Col>
            </Row>

            <Row className="mb-10">
                {/* Left Column */}
                <Col className="relative font-mono text-sm py-3" xxl={5} xl={5} lg={5} md={12} sm={12} xs={12}>
                    <a href="https://online.cmc.co.th/" target="_blank" rel="noopener noreferrer">
                        <Image
                            src={Project3}
                            alt="Aquaverse Ticket Image"
                            className="object-contain custom-rounded hover-soak px-2" width={'100%'}
                        />
                    </a>
                </Col>


                {/* Right Column */}
                <Col className="relative font-mono text-white py-3 px-5 custom-rounded flex flex-col justify-center box-hover" xxl={7} xl={7} lg={7} md={11} sm={11} xs={11}>
                    <h3 className='text-xl font-bold mb-3'>
                        <span className='text-main'>CMC Online Booking</span>
                    </h3>
                    <div className="font-mono text-jobs mt-1 mb-3">
                        This project is developed to allow users to sign up, log in, and book condominium rooms online conveniently and securely through a website built using Next.js technology. It connects to MySQL and SQL databases for storing member information and booking details.
                    </div>
                    <Row>
                        <Col md={12}>
                            <div className="text-main mb-2">Key Features</div>
                            <Col className="mt-2 space-y-3 mb-5">
                                <p className="text-sm text-slate-400 mt-1"> ▹ <strong>Sign Up :</strong> Users can sign up by entering personal information such as name, email, and password to create an account.</p>
                                <p className="text-sm text-slate-400 mt-1"> ▹ <strong>Sign In :</strong> Users can log in with their registered account details to access the room booking system.</p>
                                <p className="text-sm text-slate-400 mt-1"> ▹  <strong>Profile Management :</strong> Users can view and update their personal information, such as address and change passwords.</p>
                                <p className="text-sm text-slate-400 mt-1"> ▹ <strong>Condominium Room Booking :</strong> Users can select the floor plan and available unit of their choice through the website.</p>
                                {/* <p className="text-sm text-slate-400 mt-1"> ▹ <strong>Database Integration :</strong> The system uses MySQL to store member and booking information and SQL to fetch room data for display.</p>
                                <p className="text-sm text-slate-400 mt-1"> ▹ <strong>Booking Notifications via Messaging API :</strong> When a room is booked, the system sends a notification with booking details to the seller.</p> */}
                            </Col>
                        </Col>
                        <Col md={12}>
                            <div className="text-main mb-2">Tools and frameworks I actively use.</div>
                            <Col className="mt-2 space-y-3 mb-5">
                                <p className="text-sm text-slate-400 mt-1"> ▹ React</p>
                                <p className="text-sm text-slate-400 mt-1"> ▹ Bootstrap</p>
                                <p className="text-sm text-slate-400 mt-1"> ▹ CSS</p>
                                <p className="text-sm text-slate-400 mt-1"> ▹ REST API</p>
                            </Col>
                        </Col>
                    </Row>




                    <a href="https://online.cmc.co.th/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className=" px-5 py-3 border text-main custom-rounded text-center w-max" >
                        View Project
                    </a>
                </Col>
            </Row>


            <Row className="m-auto m-center">
                <h4 className="uppercase text-title text-white ">
                    <span className="text-main">Figma </span>Projects
                </h4>
                <FigmaProjects />
            </Row>

            <Row className="m-auto m-center">
                <h4 className="uppercase text-title text-white">
                    <span className="text-main">Wordpress </span>Projects
                </h4>
                <WordpressProjects />
            </Row>
        </Col>
    )
}

export default Projects